// App-Badge: die kleine Zahl auf dem Home-Bildschirm-Icon. Auf iOS ab 16.4 in
// der installierten PWA verfügbar, sonst ein stilles No-op - kein Feature-
// Check-Aufwand nötig, weil ein fehlendes `setAppBadge` einfach optional
// verkettet wird. Das ist der PWA-Ersatz für eine Live Activity, nicht ein
// Nachbau davon: keine Sperrbildschirm-Kachel, nur eine Zahl auf dem Icon.

interface NavigatorWithBadge {
  setAppBadge?: (count?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
}

const nav = () => navigator as unknown as NavigatorWithBadge;

export async function setBadge(count: number): Promise<void> {
  try {
    await nav().setAppBadge?.(Math.max(0, Math.round(count)));
  } catch {
    // Nicht unterstützt oder verweigert - egal, die Push-Nachrichten bleiben.
  }
}

export async function clearBadge(): Promise<void> {
  try {
    await nav().clearAppBadge?.();
  } catch {
    // egal
  }
}
